import { PayloadAction } from '@reduxjs/toolkit';
import type { IUserProfile } from '../../types';
import { createSliceSteamup } from '../common';

interface IUserListState {
  loading: boolean;
  list: IUserProfile[];
  filter: {
    input: string,
    option: 'email'|'name',
  }
}

const userListSlice = createSliceSteamup(
  'userList',
  {
    loading: true,
    list: [],
    filter: {
      input: '',
      option: 'email',
    },
  } as IUserListState,
  {
    setListInit(state, { payload }: PayloadAction<(typeof state.list)>) {
      state.list = payload;
    },
    setKeyword(state, { payload }: PayloadAction<(typeof state.filter.input)>) {
      state.filter.input = payload;
    },
    setOption(state, { payload }: PayloadAction<(typeof state.filter.option)>) {
      state.filter.option = payload;
    },
  },
);

export default userListSlice;
